import { type ShipmentContainer } from 'core/container-details/domain/ShipmentContainer'
import { isOfferExpired, type Load as BaseLoad } from 'core/domain/Load'

import { isTenderAvailable, type Tender } from './Tender'

export type Attachment = {
  id: number
  fileName: string
}

export type TenderLoad = BaseLoad & {
  carrier1xpLink?: string
  tender: Tender
  type: 'tender'
  rateUUID?: string
  powerOnly: boolean
  attachments?: Array<Attachment>
  quoteUUID?: string
  providerRateId?: string
  container?: ShipmentContainer
}

export type Load = TenderLoad

export function isTenderLoad(load: Load): boolean {
  return load.type === 'tender'
}

export function canConfirmLoad(load: Load) {
  const isExpired = isOfferExpired(load)
  const isTender = isTenderLoad(load)

  if (isTender) {
    const isAvailable = isTenderAvailable(load.tender)
    return isAvailable && !isExpired
  }

  return !isExpired
}

export function hasAttachments(load: Load): boolean {
  return Array.isArray(load.attachments) && load.attachments.length > 0
}
